import { Component, Input } from '@angular/core';
import { StoryBlokGridImage } from '../../models/storyblok-custom-linked-grid.model';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import {
  CustomLinkedGridApplicationEvent
} from '~shared/modules/application-event/models/custom-linked-grid-event.model';

@Component({
  selector: 'app-custom-linked-grid',
  templateUrl: './custom-linked-grid.component.html',
  styleUrls: ['./custom-linked-grid.component.scss'],
})
export class CustomLinkedComponent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() images: StoryBlokGridImage;

  constructor(private applicationEventService: ApplicationEventService) {}

  private isExternalURL(url): boolean {
    return new URL(url).origin !== location.origin;
  }

  goTo(url: string): void {
    if (this.isExternalURL(url)) {
      window.open(url, '_blank');
      return;
    }

    window.location.href = url;
  }

  // GA click event
  clickGridBlock(url: string): void {
    this.applicationEventService.publish(new CustomLinkedGridApplicationEvent(url));
  }
}
